// const addInfo = {
//   title: 'KPIDashboard',
//   icon: 'dashboard'
// }
const KPIRouter = {
  path: '/kpi',
  meta: {
    title: 'KPIDashboard',
    icon: 'dashboard',
    permission: ['kpi_dashboard']
  },
  children: [
    {
      path: 'kpi-dashboard',
      component: () => import('@/views/KPIDashboard/kpi-dashboard'),
      name: 'KPIDashboard',
      meta: { title: 'KPIDashboard', parent: { title: 'KPIDashboard', icon: 'dashboard' }, permission: ['kpi_dashboard'] }
    },
    {
      path: 'banner-image-management',
      component: () => import('@/views/KPIDashboard/banner-image-management'),
      name: 'BannerImageManagement',
      meta: { title: 'BannerImageManagement', parent: { title: 'KPIDashboard' } },
      hidden: true
    }
    // {
    //   path: 'driver-details/:id',
    //   component: () => import('@/views/driver/ManageDriver/driver-details'),
    //   name: 'DriverDetails',
    //   hidden: true,
    //   meta: { title: 'DriverDetails', parent: addInfo, activeMenu: '/driver/manage-driver', enableBack: true, backPage: 'ManageDriver' }
    // },
  ]
}

export default KPIRouter
